import {
  type QueryFunctionContext,
  type QueryObserverOptions,
  useQuery
} from 'react-query'

import useAuth from 'hooks/use-auth'
import { fetchQueryData } from 'hooks/use-gremlin-query'
import { getEndpointWithParams } from 'queries/queries-utils'
import { sharedAssetsQueryKeys } from 'queries/sharedAssets/query-keys'

import type { AxiosError } from 'axios'
import type { SharedAssetsResponse } from 'types/api/sharedAssets/sharedAssets'

function fetchSharedAssets({
  queryKey: [endpoint, params]
}: QueryFunctionContext<ReturnType<typeof sharedAssetsQueryKeys.get>>) {
  const endpointWithParams = getEndpointWithParams(endpoint, params)

  return fetchQueryData<SharedAssetsResponse>(endpointWithParams)
}

export const useGetSharedAssets = (
  options?: Omit<
    QueryObserverOptions<SharedAssetsResponse, AxiosError>,
    'queryFn' | 'queryKey'
  >
) => {
  const { currentTeamId: teamId } = useAuth()

  return useQuery<SharedAssetsResponse, AxiosError>({
    ...options,
    queryKey: sharedAssetsQueryKeys.get({ teamId }),
    queryFn: fetchSharedAssets
  })
}
